import { string } from 'prop-types';
import { Select } from 'antd';
import CustomIcon from '@components/shared/CustomIcon';
import s from './UniversalSearch.module.less';

export const OptionGroupHeader = ({ title, iconType }) => (
  <div className={s.optionGroupHeader}>
    {!!iconType && <CustomIcon type={iconType} className={s.optionGroupHeader__icon} />}
    <div className={s.optionGroupHeader__title}>{title}</div>
  </div>
);

/* eslint-disable react/no-danger */
export const generateLocationsOptionGroup = locationsSearchResults => (
  <Select.OptGroup
    key="locations"
    label={<OptionGroupHeader title="Locations" iconType="pin-drop" />}
  >
    {locationsSearchResults.map(location => (
      <Select.Option key={location.value} value={location.value} label={location.label}>
        <div className={s.option} data-testid={`locationOption-${location.value}`}>
          <div
            className={s.optionMainText}
            dangerouslySetInnerHTML={{ __html: location.highlightedLabel }}
          />
          <div className={s.optionSubText}>{location.labelAsideText}</div>
        </div>
      </Select.Option>
    ))}
  </Select.OptGroup>
);

export const generateBuildingsOptionGroup = buildingSearchResults => (
  <Select.OptGroup
    key="buildings"
    label={<OptionGroupHeader title="Buildings" iconType="buildings-multiple" />}
  >
    {buildingSearchResults.map(building => (
      <Select.Option key={`building|${building.value}`}>
        <div className={s.option} data-testid={`buildingOption-${building.value}`}>
          <div
            className={s.optionMainText}
            dangerouslySetInnerHTML={{ __html: building.highlightedLabel }}
          />
          <div className={s.optionSubText}>{building.labelAsideText}</div>
        </div>
      </Select.Option>
    ))}
  </Select.OptGroup>
);
/* eslint-enable react/no-danger */

OptionGroupHeader.propTypes = {
  title: string.isRequired,
  iconType: string.isRequired,
};
